import {createSinglePathSVG} from './TEMPLATE'

export const DotGrid_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M2 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm16 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-6-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z',
})
